// @ts-strict-ignore
import { DEFAULT_BOARD_TIMELINE, DEFAULT_LANGUAGE } from '../../app.constants';
import { ExtendedDescriptionType } from '../../model/client-model/extended-description/extended-description-type';
import { Layout } from '../../model/client-model/settings/board-settings/layout';
import { UnaddressedEmissionsDisplay } from '../../model/client-model/settings/board-settings/unaddressed-emissions-display';
import { EmissionFactorCalculationMethod } from '../../model/enums/emission-factor-calculation-method';
import { MeasurementSystem } from '../../model/enums/measurement-system';
import { WeightMetric } from '../../model/prefixed-unit/weight.metric';
import { BoardViewModel } from './board.types';

const inventoryGoal: BoardViewModel['inventory/goal'] = {
  boardSettings: {
    reductionGoals: [
      {
        id: null,
        ratified: null,
        ratifiedDate: null,
        goal: null,
        referenceYear: null,
        referenceYearEmissions: null,
        additionalGoalsByYear: null,
      },
    ],
    timeline: DEFAULT_BOARD_TIMELINE,
    displayUnit: WeightMetric.Tonne,
    measurementSystem: MeasurementSystem.Metric,
  },
};

const dashboardStories: Omit<
  BoardViewModel['dashboard/stories'],
  'id' | '_etag' | 'title' | 'childNodes' | 'supplyChildNodes'
> = {
  boardSettings: {
    internationalisation: { defaultLanguage: DEFAULT_LANGUAGE },
    introductionTitle: '',
    introductionSummary: '',
    pointOfEntrySettings: {
      header: {
        boardTitle: '',
        country: '',
        tagline: '',
        backgroundImage: { large: '' },
        backgroundImageCredits: '',
        about: '',
        taglineSubText: '',
      },
      footer: { bodyLeft: '', bodyRight: '', images: [] },
    },
    goalTitle: '',
    emissionsPathways: {
      title: '',
      description: '',
      image: '',
      imageCredit: '',
    },
    pathwayGap: {
      summary: '',
    },
    rootNodeProperties: { diagramHeader: '' },
    extendedDescription: {
      data: {
        texts: [],
        images: [],
      },
      type: ExtendedDescriptionType.ImagesAndTexts,
    },
    activityHierarchy: '',
    totalEmissions: null,
    timeline: DEFAULT_BOARD_TIMELINE,
  },
};

const pathwaysTransitionHierarchy: Omit<
  BoardViewModel['pathways/transition-hierarchy'],
  'id' | 'title' | 'childNodes' | 'supplyChildNodes' | 'parameters' | '_etag' | '_ts'
> = {
  boardSettings: {
    timeline: DEFAULT_BOARD_TIMELINE,
    displayUnit: WeightMetric.Tonne,
    internationalisation: { defaultLanguage: DEFAULT_LANGUAGE },
    auxiliaryActionProperties: [],
    imgURL: '',
    transitionTargetNodes: { layout: Layout.TARGET_AND_TEXT, showCardImages: false },
    doNotDistributeUntargeted: false,
    unaddressedEmissionsDisplay: UnaddressedEmissionsDisplay.None,
    useNewTargetedEmissions: false,
    electricityEmissionFactorType: EmissionFactorCalculationMethod.Calculated,
  },
};

export const boardViewModelDefaultValues = {
  'inventory/goal': inventoryGoal,
  'dashboard/stories': dashboardStories,
  'dashboard/emission-stories': dashboardStories,
  'pathways/transition-hierarchy': pathwaysTransitionHierarchy,
};
